var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.51,28h-28a3.17,3.17,0,0,1-2.36-1.09A3.63,3.63,0,0,1,.28,24.1C1.48,14.76,8.88,7.72,17.5,7.72s16,7,17.22,16.38a3.63,3.63,0,0,1-.85,2.84A3.17,3.17,0,0,1,31.51,28Zm-14-17.81c-7.37,0-13.7,6.11-14.74,14.2a1.12,1.12,0,0,0,.25.87.64.64,0,0,0,.48.24h28a.64.64,0,0,0,.48-.24,1.12,1.12,0,0,0,.25-.87C31.2,16.33,24.87,10.22,17.5,10.22Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.38,12.74a1.17,1.17,0,0,1-.6-.16,1.24,1.24,0,0,1-.5-1.69l1.77-3.27a1.25,1.25,0,1,1,2.2,1.2l-1.77,3.26A1.26,1.26,0,0,1,27.38,12.74Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.68,12.74a1.26,1.26,0,0,1-1.1-.66L4.81,8.82A1.25,1.25,0,1,1,7,7.62l1.77,3.27a1.25,1.25,0,0,1-.5,1.69A1.2,1.2,0,0,1,7.68,12.74Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.79,20.7a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.05,20.78a1.88,1.88,0,0,0,0-3.75,1.88,1.88,0,0,0,0,3.75Z"
});

function SvgAndroidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    id: "Layer_2",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android-icon.ec560eea7ab9466df54aa91bbf1c8983.svg";
export { ForwardRef as ReactComponent };